import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';

import {ConfigService} from '@ngmedax/config';
import {RegistryService} from '@ngmedax/registry';
import {configKeys} from '../survey-code.config-keys';
import {SurveyCode} from '../../../types';


@Injectable()
export class SurveyService {
  /**
   * Injects dependencies
   */
  public constructor(
    private registryService: RegistryService,
    private configService: ConfigService,
    private http: HttpClient
  ) {
  }

  public getSurveyCode(code: string, birthYear: string): Promise<SurveyCode> {
    const basePath = `${this.getSurveyApiUrl()}/code/${code}/${birthYear}`;

    return new Promise((resolve, reject) => {
      this.http.get(basePath, {headers: this.getAuthHeaders()})
        .subscribe((result: any) => {
            if (!result || typeof result !== 'object' || !result.success) {
              reject(result.message || 'Unknown error');
              return;
            }
            const link = result.link || '';
            const surveyCode = result.surveyCode || {};
            Object.assign(surveyCode, {link});

            resolve(surveyCode);
          },
          error => {
            reject(error);
          });
    });
  }

  /**
   * Returns api url for survey
   *
   * @param {string} suffix
   * @returns {string}
   */
  private getSurveyApiUrl(suffix: string = null): string {
    return this.buildUrl(configKeys.SURVEY_API_URI_CONFIG_KEY, suffix);
  }

  /**
   * Returns url for config key. Adds auth information to url path when api is not deprecated
   */
  private buildUrl(configKey: string, suffix = null): string {
    let uri = this.configService.get(configKey);

    if (suffix) {
      uri = `${uri}${suffix}`;
    }

    return uri;
  }

  /**
   * Returns auth headers by auth token and tenant id
   */
  private getAuthHeaders(): any {
    const headers: any = {};
    const authToken = this.registryService.get(configKeys.SESSION_AUTH_TOKEN);
    const tenantId = this.registryService.get(configKeys.SESSION_TENANT_ID);

    if (authToken) {
      headers['X-Api-Token'] = authToken;
    }

    if (tenantId) {
      headers['X-Api-TenantId'] = `${tenantId}`;
    }

    return headers;
  }
}
